export class MonitoredWorkOrderDatumResponse {
  Created: Date;
  DataName: string;
  DataValue: string;
  WorkOrderDatumID: number;
  WorkOrderID: number;
}
